/* eslint-disable no-nested-ternary */
import classnames from "classnames";
import PropTypes from "prop-types";
import { Component } from "react";
import HideIf from "util/HideIf";
import { getVideosWithThumbnails } from "util/videoThumbnailUtil";
import { deepEqual } from "../../util/lodash/deepEqual";
import VideoThumbnail from "./video/VideoThumbnail";
import styles from "./videoSection.module.scss";

const propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      youtubeId: PropTypes.string,
      vimeoId: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: "",
};

export class VideoSection extends Component {
  constructor(props: any, context: any) {
    super(props, context);

    this.state = {
      isVideoPlaying: false,
      selectedVideoId: "",
      isVimeoVideo: false,
      videoThumbnails: [],
    };

    this.handleClickPlay = this.handleClickPlay.bind(this);
    this.handleSelectVideo = this.handleSelectVideo.bind(this);
  }

  componentDidMount() {
    getVideosWithThumbnails(this.props.videos)
      .then((videoThumbnails) => {
        this.setState({
          videoThumbnails,
          selectedVideoId: videoThumbnails[0]?.id || "",
          isVimeoVideo: videoThumbnails[0]?.isVimeo || false,
        });
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!deepEqual(nextProps.videos, this.props.videos)) {
      getVideosWithThumbnails(nextProps.videos).then((videoThumbnails) => {
        this.setState({
          videoThumbnails,
          isVideoPlaying: false,
          selectedVideoId: videoThumbnails[0]?.id || "",
          isVimeoVideo: videoThumbnails[0]?.isVimeo || false,
        });
      });
    }
  }

  handleClickPlay() {
    this.setState({
      isVideoPlaying: true,
    });
  }

  handleSelectVideo(videoId: string, isVimeoVideo: boolean) {
    this.setState({
      isVideoPlaying: true,
      selectedVideoId: videoId,
      isVimeoVideo,
    });
  }

  render() {
    const {
      className, showThumbnail = true, title = "Videos",
    } = this.props;

    const videoUrl = this.state.videoThumbnails.find(
      (video) => video.id === this.state.selectedVideoId,
    )?.thumbnailUrl;

    return (
      <div className={`${className} ${styles.video_container}`}>
        <HideIf show={title}>
          <h2>{title}</h2>
        </HideIf>

        {!this.state.isVideoPlaying && videoUrl && (
          <div
            className={`${styles.video_thumbnail_container} ${className}`}
            style={{
              backgroundImage: `url(${videoUrl})`,
            }}
          >
            <div className={styles.video_thumbnail_mask}>
              <img
                alt="videoplay"
                src={`${process.env.NEXT_PUBLIC_ROOT_URL}/images/common/videoplay.png`}
                onClick={this.handleClickPlay}
              />
            </div>
          </div>
        )}

        {this.state.isVideoPlaying && (
          <div
            className={classnames("text-center", {
              [styles.vimeo_video_container]: this.state.isVimeoVideo,
            })}
          >
            <iframe
              title="Video Player"
              allowFullScreen
              src={
                this.state.isVimeoVideo
                  ? `https://player.vimeo.com/video/${this.state.selectedVideoId}?autoplay=1`
                  : `https://www.youtube.com/embed/${this.state.selectedVideoId}?wmode=transparent&rel=0&showinfo=0&fs=1&autoplay=1`
              }
              data-clarity-mask="True"
            />
          </div>
        )}

        <HideIf show={showThumbnail}>
          <div className="row">
            {this.state.videoThumbnails.map((video: any, iVideo: any) => (
              <div key={`video_thumb_${iVideo}`} className="col-xs-12 col-sm-6 col-lg-4">
                <VideoThumbnail
                  youtubeId={video.youtubeId}
                  vimeoId={video.vimeoId}
                  title={video.title}
                  thumbnailUrl={video.thumbnailUrl}
                  vimeoType={video.isVimeo}
                  onSelect={this.handleSelectVideo}
                />
              </div>
            ))}
          </div>
        </HideIf>
      </div>
    );
  }
}

VideoSection.propTypes = propTypes;

VideoSection.defaultProps = defaultProps;

export default VideoSection;
